export const cleanedAddresses = [
  ""
];

export const merkleRoot = "0x37de3c6fac51694a622ff1c9ada0516ad763cc7aac00a672062c80ae3217f584";

export const lastUpdatedTimestamp = new Date(1738005456813);
